import React from 'react';
import { bool, shape, string } from 'prop-types';

const MapMarkerColor = ({
  className = 'icon',
  notUseClass = false,
  style = { color: '#696f88' },
}) => (
  <svg className={notUseClass ? '' : className} style={style} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M10.5 10.5C10.5 11.325 11.175 12 12 12C12.825 12 13.5 11.325 13.5 10.5C13.5 9.675 12.825 9 12 9C11.175 9 10.5 9.675 10.5 10.5Z" fill="currentColor" />
    <path fillRule="evenodd" clipRule="evenodd" d="M18 10.65C18 6.915 15.15 4.5 12 4.5C8.85 4.5 6 6.915 6 10.65C6 13.14 8.0025 16.0875 12 19.5C15.9975 16.0875 18 13.14 18 10.65ZM12 6C14.5125 6 16.5 7.9275 16.5 10.65C16.5 12.405 15.0375 14.73 12 17.505C8.9625 14.73 7.5 12.405 7.5 10.65C7.5 7.9275 9.4875 6 12 6Z" fill="currentColor" />
  </svg>
);

MapMarkerColor.propTypes = {
  className: string,
  notUseClass: bool,
  style: shape({}),
};

export default MapMarkerColor;
